angular.module('impactx.rfx').controller('RFXSmartFormItemCtrl', [
    'TranslationService',
    '$mdDialog',
    'RFXBuyerService',
    'SmartFormTemplateCache',
    'dataGen',
    RFXSmartFormItemController
]);

function RFXSmartFormItemController(TranslationService, $mdDialog, RFXBuyerService, SmartFormTemplateCache, dataGen) {
    var self = this;
    self.itemCopy = angular.copy(self.item, self.itemCopy);
    self.trns.save = TranslationService.get('accept');
    self.trns.abort = TranslationService.get('abort');
    self.trns.required = TranslationService.get('required');
    activate();

    self.getSmartForm = function (selection) {
        if (selection) {
            RFXBuyerService.getSmartFormTemplateData(self.rfqhId, selection.id).then(function (response) {
                if (impactX.isDefined(response, 'data')) {
                    if (impactX.isDefined(self, 'itemCopy.smartForm.identifier')) {
                        SmartFormTemplateCache.removeForm(self.itemCopy.smartForm.identifier);
                    }
                    self.itemCopy = response.data;
                    self.itemCopy.selectedSmartFormTemplate = selection;
                }
            });
        }
    };

    self.save = function () {
        removeSelection();
        self.itemCopy.id = self.itemCopy.id || 0;
        SmartFormTemplateCache.removeForm(self.itemCopy.smartForm.identifier);
        dataGen.postAsForm({}, {smartForm: self.itemCopy.smartForm}, "/rfx/buyer/item/smartform/attributes").then(function (data) {
            self.itemCopy.smartFormAttributes = data.data.smartFormAttributes;
            $mdDialog.hide(self.itemCopy);
        });
    };

    self.abort = function () {
        removeSelection();
        if (self.itemCopy && self.itemCopy.smartForm) {
            SmartFormTemplateCache.removeForm(self.itemCopy.smartForm.identifier);
        }
        $mdDialog.cancel();
    };

    function removeSelection() {
        if (self.smartFormTemplates) {
            self.smartFormTemplates.selected = undefined;
        }
    }

    function activate() {
        var itemId = impactX.isDefined(self, 'item.id');
        var sfiId = impactX.isDefined(self, 'item.smartForm.id');
        if (!!itemId && sfiId > 0) {
            if (!impactX.isDefined(self, 'itemCopy.smartForm')) {
                RFXBuyerService.getItemData(self.rfqhId, itemId, 0, sfiId).then(function (item) {
                      var orderAmount = self.itemCopy.orderAmount;
                      self.itemCopy = item;
                      self.itemCopy.orderAmount = orderAmount;
                });
            }
        }
        else {
            var smartFormTitle = impactX.isDefined(self, 'item.smartForm.title');
            if (smartFormTitle) {
                angular.forEach(self.smartFormTemplates.entries, function (template) {
                    if (template.value === smartFormTitle) {
                        self.smartFormTemplates.selected = template;
                    }
                })
            }
        }
    }
}